export default __webpack_public_path__ + "static/media/DancingScript.352941fa.ttf";